import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PayInvoicePage from "@/pages/PayInvoicePage";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="auth-loading">
        <span className="text-xs tracking-[0.3em] text-coyote">VERIFYING CLEARANCE<span className="blink text-alert">_</span></span>
      </div>
    );
  }
  return user ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/pay" element={<PayInvoicePage />} />
            <Route path="/pay/:invoiceId" element={<PayInvoicePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          toastOptions={{
            style: {
              background: "#0A0D08",
              border: "1px solid #4A5D23",
              borderRadius: 0,
              color: "#E4E6DF",
              fontFamily: "'JetBrains Mono', monospace",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
